import { AtomItem } from './AtomItem'
import { connect } from 'react-redux'

const mapStateToProps = ({ activeBot }) => ({ activeBotId: activeBot?.id })

export default connect(mapStateToProps)(AtomItem)
